const n = "ls-focus-ring";
function i(s) {
  s && s.classList.add(n);
}
function o(s) {
  s && s.classList.remove(n);
}
export {
  n as F,
  i as a,
  o as r
};
//# sourceMappingURL=focus-BJKdC9pu.js.map
